module.exports = __webpack_public_path__ + "static/media/performance.14cbe620.gif";